<div class="wrapper-modal">
  <div class="wrapper-modal-content delete">
    <div class="wrapper-modal-image">
      <img [src]="modalIcon" alt="">
    </div>
    <div class="modal-title">{{modalTitle | translate}}</div>
    <div class="modal-description">{{modalDescription | translate}}</div>
    <div class="modal-buttons">
      <button class="custom-btn custom-btn--outline-red" (click)="cancelModal.emit()"><span>{{cancelBtnText |
          translate}}</span></button>
      <button class="custom-btn custom-btn--delete" (click)="confirmModal.emit()"><span>{{confirmBtnText |
          translate}}</span></button>
    </div>
  </div>
</div>